/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'blog': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path d="M17.5 4.5C15.55 4.5 13.45 4.9 12 6C10.55 4.9 8.45 4.5 6.5 4.5C4.55 4.5 2.45 4.9 1 6V20.65C1 21.3 1.73 21.1 1.75 21.1C3.1 20.45 5.05 20 6.5 20C8.45 20 10.55 20.4 12 21.5C13.35 20.65 15.8 20 17.5 20C19.15 20 20.85 20.3 22.25 21.05C22.66 21.26 23 20.86 23 20.6V6C21.51 4.88 19.37 4.5 17.5 4.5ZM21 18.5C19.9 18.15 18.7 18 17.5 18C15.8 18 13.35 18.65 12 19.5V8C13.35 7.15 15.8 6.5 17.5 6.5C18.7 6.5 19.9 6.65 21 7V18.5Z" _fill="#fff"/>'
  }
})